import { t } from 'i18next';

import styles from './EmployerPortalJobDetail.module.css';
import { Typography } from '../../../Typography/typography';
import { seeMoreTitle } from './SeeMoreTitle';
import { jobRequirmentUI } from './JobRequirment';
import {
    Pin,
    Skills,
    WorkExp,
    Education,
    DollarIcon,
    BriefcaseWhite,
    LanguageIconWhite,
} from '../../../../assets/images/icons';

export const jobDetailUI = (jobDetail, setShowFullDescription, showFullDescription) => {
    const language = jobDetail?.job_languages
        ?.filter(e => e?.language_code && e.language_code !== "undefined")
        ?.map(e => t(`general.language.${e.language_code?.toUpperCase()}`))
        ?.join(", ") || "";

    const skills = jobDetail?.skillsData?.join(", ") || "";
    const salaryRange = jobDetail?.salary_to && jobDetail?.salary_from
        ? `$${jobDetail.salary_to}-${jobDetail.salary_from}${jobDetail.salaryrate ? (`/` + t('CompensationAndbenefits.' + (jobDetail.salaryrate?.[0]?.toUpperCase() + jobDetail.salaryrate?.slice(1)))) : ''
        }`
        : "";
    const JOBREQUIRMENTS = [
        { title: t("jobRequirements.locationType"), desc: jobDetail?.job_location ? t(`forms.jobLocation.${jobDetail.job_location}`) : "", icon: Pin },
        { title: t("jobRequirements.jobCategory"), desc: jobDetail?.jobCategory || "", icon: BriefcaseWhite },
        { title: t("jobRequirements.jobType"), desc: jobDetail?.job_type ? t(`general.UI.${jobDetail.job_type}`) : "", icon: BriefcaseWhite },
        { title: t("jobRequirements.salaryRange"), desc: salaryRange, icon: DollarIcon },
        { title: t("jobRequirements.education"), desc: jobDetail?.education_level ? t(`general.education_levels.${jobDetail.education_level}`) : "", icon: Education },
        { title: t("jobRequirements.languages"), desc: language, icon: LanguageIconWhite },
        { title: t("jobRequirements.workExperience"), desc: jobDetail?.minworkexp && jobDetail?.maxworkexp ? `${jobDetail.minworkexp}-${jobDetail.maxworkexp} ${t("general.UI.years")}` : "", icon: WorkExp },
        { title: t("jobRequirements.skills"), desc: skills, icon: Skills },
    ].filter(item => Boolean(item.desc));
    
    return (
        <div className={styles.jobDetailSection}>
            <Typography title={t('forms.manage_job.job_details')} weight={'600'} fontSize={16} />
            {seeMoreTitle(jobDetail?.description || "", 150, setShowFullDescription, showFullDescription)}
            <div className={styles.jobDetailsContainer}>
                {JOBREQUIRMENTS.map((item, index) => (
                    <div key={index} className={styles.row}>
                        {jobRequirmentUI(item.title, item.desc, item.icon)}
                    </div>
                ))}
            </div>
        </div>
    );
};